module.exports = {"513229100":"马尔康镇","513229101":"卓克基镇","513229102":"松岗镇","513229200":"梭磨乡","513229201":"白湾乡","513229202":"党坝乡","513229203":"木尔宗乡","513229204":"脚木足乡","513229205":"沙尔宗乡","513229206":"龙尔甲乡","513229207":"大藏乡","513229208":"康山乡","513229209":"草登乡","513229210":"日部乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513229.json
// module id = 2538
// module chunks = 0